// extracted by mini-css-extract-plugin
export default {"tcContainer":"talent-calculator-main_tcContainer__t2M2J"};